import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { IRootReducerState } from 'state/reducers'

export const useHasWarrantyPermission = () => {
  const selectedRegion = useSelector((state: IRootReducerState) => state.region.selectedRegion)

  const checkPermission = useCallback(() => {
    const isNLRegion = selectedRegion.startsWith('nl') || selectedRegion.includes('.nl.')
    const isFRRegion = selectedRegion.startsWith('fr') || selectedRegion.includes('.fr.')
    return isNLRegion || isFRRegion || selectedRegion === 'localhost'
  }, [selectedRegion])

  return {
    hasPermission: checkPermission()
  }
}
